import type { ReactNode } from 'react';
import Button from 'devextreme-react/button';
import './minimalEditorChrome.css';

export interface MinimalEditorChromeProps {
  title: string;
  onClose?: () => void;
  children: ReactNode;
}

export function MinimalEditorChrome({ title, onClose, children }: MinimalEditorChromeProps) {
  const handleClose = () => {
    if (onClose) {
      onClose();
      return;
    }
    window.close();
  };

  return (
    <div className="minimal-editor-chrome">
      <header className="minimal-editor-chrome__header" aria-label="Editor">
        <span className="minimal-editor-chrome__brand" aria-hidden>
          JARVIS
        </span>
        <span className="minimal-editor-chrome__title" title={title}>
          {title}
        </span>
        <Button
          className="minimal-editor-chrome__close"
          icon="close"
          stylingMode="text"
          hint="Close"
          onClick={handleClose}
        />
      </header>
      <div className="minimal-editor-chrome__body">{children}</div>
    </div>
  );
}

/** Layout route helper: skip host AppShell when `?chrome=minimal` is present. */
export function MinimalEditorLayout({ children }: { children: ReactNode }) {
  return <div className="minimal-editor-layout">{children}</div>;
}
